import { v4 as uuidv4 } from 'uuid'

import { AD_CREATIVES, CLICK_THROUGH_LINK, MEDIA_HEIGHT, MEDIA_WIDTH, NAME, THIRD_PARTY_TAG } from '../../../../fields'
import { IS_QUARANTINE } from '../../../../../../reusableFields'

export const initialAdCreativeTag = {
  [CLICK_THROUGH_LINK]: 'https://',
  [NAME]: '',
  [THIRD_PARTY_TAG]: '',
  [MEDIA_WIDTH]: null,
  [MEDIA_HEIGHT]: null
}

export const getInitialValues = isInternalAdCreation => ({
  [IS_QUARANTINE]: isInternalAdCreation,
  [AD_CREATIVES]: [{ ...initialAdCreativeTag, id: uuidv4() }]
})
